export enum ConcurrenceEnums {
  prefacturacion = 1,
  facturacion = 2,
  ocupacion = 3,
  desbloquearCortes = 4
}